import { secureLocalStorageSet } from "../../../helpers";
import { Dispatch } from "redux";
import { addActiveCompany } from '../../../services/user'

import { UserAction, UserActionTypes } from "../../types/user";

export const addActiveCompanyData = (request: any) => {
  return (dispatch: Dispatch<UserAction>) => {
    return new Promise(() => {
      dispatch({ type: UserActionTypes.ADD_ACTIVE_COMPANY_REQUEST })
        const req = {
            customerNo: request.customerNo
        }
      addActiveCompany(req)
        .then(response => {
          // localStorage.setItem("permissions", JSON.stringify(response.permissions))
          secureLocalStorageSet('permissions', response.permissions)
          // localStorage.setItem("rol", response.role)
          secureLocalStorageSet("rol", response.role)

          dispatch({
            payload: {
              result: response,
            },
            type: UserActionTypes.ADD_ACTIVE_COMPANY_SUCCESS,
          })
          request.history.push('/');
        })
        .catch((error: any) => {
          dispatch({
            error: {
              result: error.response,
            },
            type: UserActionTypes.ADD_ACTIVE_COMPANY_ERROR,
          })
          // Notify(error.response.data.messages[0].MESSAGE)
        })
    })
  }
}